'use client';

import { useQuery } from '@tanstack/react-query';
import type { LocationPreferences } from '@/features/locations/domain/model/location-preferences';
import { getLocationPreferences } from '@/features/locations/presentation/actions/get-location-preferences';
import { totemsKeys } from '@/features/totems/presentation/queries/totems.queries';

export function useLocationPreference(locationId?: string) {
  return useQuery({
    queryKey: totemsKeys.locationPreferences(locationId),
    queryFn: async () => {
      const data = await getLocationPreferences(locationId!);
      return data as (LocationPreferences & { locations?: { id: string; slug: string } }) | null;
    },
    enabled: !!locationId,
  });
}
